import { QuestionnaireStatus } from "@generated/client/graphql";
import {
    ArrayParam,
    BooleanParam,
    decodeArray,
    encodeArray,
    NumberParam,
    StringParam,
    withDefault,
} from "use-query-params";

const QuestionnaireStatusParam = {
    encode: (array: (string | null)[]) => encodeArray(array),

    decode: (arrayStr: string | (string | null)[] | null | undefined) => {
        const decodedValues = decodeArray(arrayStr);
        if (Array.isArray(decodedValues)) {
            const acceptedValues = decodedValues.filter(
                (v) =>
                    !!v &&
                    typeof v === "string" &&
                    Object.values(QuestionnaireStatus).includes(
                        v as QuestionnaireStatus,
                    ),
            );
            return acceptedValues as QuestionnaireStatus[];
        }
        return [];
    },
};

export const activeFilterParamArgs = {
    searchFilter: ["search", withDefault(StringParam, "")],
    tagFilter: ["tag", withDefault(ArrayParam, [])] as const,
    questionnaireFilter: [
        "questionnaire",
        withDefault(ArrayParam, []),
    ] as const,
    progressFilter: {
        min: ["progressMin", withDefault(NumberParam, 0)],
        max: ["progressMax", withDefault(NumberParam, 100)],
    },
    statusFilter: [
        "status",
        withDefault(QuestionnaireStatusParam, []),
    ] as const,
    noQuestionnaireOnly: [
        "noQuestionnaireOnly",
        withDefault(BooleanParam, false),
    ],
} as const;
